<template>
  <div class="image-block" :style="myBlockProps.getStyles(visible)">
    <img :src="image" :alt="alt"/>
  </div>
</template>

<script>
import Block from './Block.vue';

export default {
  name: 'image-block',
  extends: Block,
  props: {
    image: { type: String, required: true },
    alt: { type: String, default: 'image' }
  }
};
</script>

<style scoped>
img {
  max-height: 100%;
  max-width: 100%;
;
}
</style>
